import { EgretLoadable } from "egret/index.js";

//import PartnerViewHomePage from "./index.jsx";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: false,
      showcontent: true,
    },
    leftSidebar: {
      show: true,
      mode: "compact",
    },
  },
  layout2Settings: {
    mode: "full",
    topbar: {
      show: false,
    },
    navbar: { show: false },
  },
  secondarySidebar: { show: false },
  footer: { show: false },
  partnerView: true,
};

const HomePage = EgretLoadable({
  loader: () => import("./index"),
});

const PartnerViewAlertPageRoutes = [
  {
    path: "/partner-alerts",
    component: HomePage,
    settings,
  },
];

export default PartnerViewAlertPageRoutes;
